import { MAX_PERCENT } from '@/constants/common';

export const decimalToPercent = (value: number) => Number((value * MAX_PERCENT).toPrecision(15));

export const getObjectKeys = <TObject extends object>(value: TObject): Extract<keyof TObject, string>[] =>
    Object.keys(value) as Extract<keyof TObject, string>[];
